import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faXmark } from "@fortawesome/free-solid-svg-icons";
import "./AboutChartToggle.scss";

export default function AboutChartToggle({ notes = "" }) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="flex flex-col gap-3 font-sans about-chart-container">
      {/* Toggle Button */}
      {/* <button
        onClick={() => setIsOpen(!isOpen)}
        className="btn btn-outline-theme action-btn"
      >
        {isOpen ? (
          <FontAwesomeIcon icon={faXmark} />
        ) : (
          <FontAwesomeIcon icon={faCircleInfo} />
        )}
        <span className="text-sm font-medium">About this chart</span>
      </button> */}

      {/* Expanded Text Panel */}
      {isOpen && (
        <div
          className="p-3 mt-2 shadow-sm"
          style={{
            backgroundColor: "#F7F7F4",
            color: "#4A4A4A",
            borderLeft: "4px solid #7C69E1", // The purple accent
            borderTopRightRadius: "8px",
            borderBottomRightRadius: "8px",
            // maxWidth: "800px",
            // fontSize: "14px",
          }}
        >
          <div className="d-flex justify-content-between align-items-start">
            <span>{notes}</span>
            <span
              className="cursor-pointer text-theme close-btn"
              onClick={() => setIsOpen(!isOpen)}
            >
              <FontAwesomeIcon icon={faXmark} />
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
